<template>
  <div class="relative">
    <div class="pt-24 pb-8 lg:px-20 md:px-20 px-5 absolute top-0 left-0 z-10">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="fsize16">Join Us</el-breadcrumb-item>
        <el-breadcrumb-item class="fsize16"
          >About Us</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <!-- <modal
      :show.sync="editModal"
      size="xl"
      centered
      modal-content-classes="cust-modal-ht"
      hide-footer
      scrollable
      hide-header
      class=" overflow-y-hidden"
    >
      <div class="text-black p-8">
        <div class="">
          <div class="flex justify-between items-center  pb-4">
            <p class="text-2xl font-semibold">ISBA Test</p>
            <img
              src="../../../assets/images/cross.png"
              class="h-8 w-8 cursor-pointer"
              alt="cross"
              @click="editModal = false"
            />
          </div>
          <div class="pt-4" v-for="(item, index) in 4" :key="index">
            <p class="clr777 font-normal text-lg">Question 1</p>
            <p class="font-medium text-2xl text-black pt-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam?
            </p>

            <b-form-group v-slot="{ ariaDescribedby }" class="pt-6">
              <div class="flex items-center">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="A"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black">Option A</span>
                </b-form-radio>
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="B"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option B</span
                  ></b-form-radio
                >
              </div>
              <div class="flex pt-3">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="C"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option C</span
                  ></b-form-radio
                >
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="D"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option D</span
                  ></b-form-radio
                >
              </div>
            </b-form-group>
          </div>
        </div>
      </div>
    </modal> -->
    <swiper class="swiper" :options="swiperOptions">
      <!-- v-for="(item, index) in 6" :key="index" -->
      <swiper-slide
        class="sm-h660px"
        v-for="(item, index) in banner.result"
        :key="index"
      >
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design2 mob-hidden">
          <img src="../../../assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="relative h-95per flex justify-end">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="h-640px bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
        >
          <div
            class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-3 relative md:hidden lg:hidden block"
          >
            <!-- <img
              src="https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/JoinUs/About-the-company.jpeg"
              class="custborderradius md:hidden lg:hidden block"
              alt="swiper-img "
            /> -->
            <img
              :src="`${$imageURL}/${item.image}`"
              class="custborderradius md:hidden lg:hidden block"
              alt="swiper-img "
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full">
            <div class="">
              <p
                class="font-semibold fsize35 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-full"
              >
                <!-- Our Story -->
                {{ item.heading }}
              </p>

              <p
                class="sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh32px sm-lh20 subtitle"
                v-html="item.description"
              ></p>
              <!-- Caregiver Saathi is the culmination of the personal life
            experiences of its founder, Bhavana Issar. She lost her father
            to a rare neurological condition called Shy-drager Syndrome and
            was a witness to her mother’s arduous caregiving journey. Her
            research over the years convinced her that the well-being of the
            caregiver is pivotal to the well-being and healing of the
            patient. With this purpose in mind, she quit her corporate role
            to build this ecosystem of support and healing for family
            caregivers. A companion or “Saathi” who provides guidance and
            comfort through trying times. -->
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full mob-hidden">
            <img
              :src="`${$imageURL}/${item.image}`"
              class="custborderradius md:block lg:block hidden"
              alt="swiper-img"
            />
            <img
              src="../../../assets/images/swiper-img/ww-mob-1.svg"
              class="md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
      },
      editModal: false,
    };
  },
  computed: {
    ...mapState("mainAboutUs", { banner: "banner" }),
  },
  async mounted() {
    try {
      await this.$store.dispatch("mainAboutUs/getall_banner");
      console.log(this.banner, "**************");
    } catch (error) {
      console.log(error);
    }
  },
};
</script>
<style>
@media (max-width: 640px) {
  .sm-h660px {
    height: 660px;
  }
}
</style>
